import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "fixed", "span", "grow", "align"];
import React from 'react';
import "./style/col.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function Col(props) {
  if (props === void 0) {
    props = {};
  }
  var {
      prefixCls = 'w-col',
      className,
      fixed,
      span,
      grow,
      align
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className, span ? prefixCls + "-" + span : null, fixed ? prefixCls + "-fixed" : null, align ? prefixCls + "-align-" + align : null, fixed ? prefixCls + "-grow-" + grow : null].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("div", _extends({
    className: cls
  }, other, {
    children: props.children
  }));
}